import { titleCaseLabel } from '@/utils/labelFormat';

const PLAN_DISPLAY_NAMES: Record<string, string> = {
  starter: 'Starter',
  basic: 'Basic',
  pro: 'Pro',
  premium: 'Premium',
  internal: 'Internal',
  free: 'Free',
};

/** Human-readable plan name for normal UI (never raw slug). */
export function formatPlanDisplayName(
  slug?: string | null,
  options?: { unlimited?: boolean },
): string {
  if (options?.unlimited) return 'Internal';
  if (!slug || !String(slug).trim()) return '—';
  const normalized = String(slug).trim().toLowerCase();
  if (normalized === 'internal') return 'Internal';
  return PLAN_DISPLAY_NAMES[normalized] ?? titleCaseLabel(normalized.replace(/_/g, ' '));
}
